import { IProcessRequestPayload, IChangeModalVisibilityPayload, ILoadDataSuccessPayload } from './types';
import actionsTypes from './actionTypes';
import {
  ChangeModalVisibilityAction,
  ClearStateAction,
  LoadReviewPendingDataSuccessAction,
  ProcessActionErrorAction,
  ProcessActionRequestAction,
  ProcessActionSuccessAction,
} from './actions.d';

const actions = {
  changeModalVisibility: (payload: IChangeModalVisibilityPayload): ChangeModalVisibilityAction => ({
    type: actionsTypes.CHANGE_MODAL_VISIBILITY,
    payload,
  }),

  loadReviewPendingDataSuccess: (payload: ILoadDataSuccessPayload): LoadReviewPendingDataSuccessAction => ({
    type: actionsTypes.LOAD_REVIEW_PENDING_DATA_SUCCESS,
    payload,
  }),

  clearState: (): ClearStateAction => ({
    type: actionsTypes.CLEAR_STATE,
  }),

  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  processActionSuccess: (): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
  }),

  processActionError: (): ProcessActionErrorAction => ({
    type: actionsTypes.PROCESS_ACTION_ERROR,
  }),

  loadDataSuccess: (): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
  }),
};

export default actions;
